import React from 'react'

const ModalBody = (props) => {
    return (
        <div className="relative px-7 py-4 flex-auto">
            {props.children}
        </div>
    )
}

export default ModalBody